export default [
  { id: 1, 작업내용: '철거공사',
    유해위험요인: '철거공사 중 장비, 철거 잔재물 등 하중으로 인해 \n건물 무너짐',
    개선대책: '1. 장비, 공법 등이 변경될 경우 재검토 및 안전성 확인\n' +
      '2. 철거된 잔재물 적재높이 관리',
  },
  { id: 2, 작업내용: '철거공사',
    유해위험요인: '철거공사 전 사전조치 미흡',
    개선대책: '1. 작업 전 탈락위험 자재 사전제거\n' +
      '2. 전기, 가스 사전 공급 차단',
  },
  { id: 3, 작업내용: '철거공사',
    유해위험요인: '철거 작업 중 석면 비산물의 위험',
    개선대책: '1. 사전 석면조사 실시 및 절차에 따른 석면 해체 및 \n    제거 실시\n' +
      '2. 작업순서, 안전보호구 착용 감독 방진마스크(특급), \n    송기마스크, 방진복, 덧신, 보호장갑 등',
  },
  { id: 4, 작업내용: '철거공사',
    유해위험요인: '현장 내 개구부 및 단부 떨어짐 방지',
    개선대책: '1. 추락 방호망 설치\n' +
      '2. 개구부 덮개 및 안전난간 설치\n' +
      '3. 추락주의 표지판 배치',
  },
  { id: 5, 작업내용: '철거공사',
    유해위험요인: '내장재 해체·제거 중 말비계, 사다리 이동식 비계 \n떨어짐 방지조치',
    개선대책: '1. 이동식 사다리 2인1조 작업\n' +
      '2. 안전모 등 보호구 지급 및 착용\n' +
      '3. 전도 방지대 등 조치 철저',
  },
  { id: 6, 작업내용: '철거공사',
    유해위험요인: '폐기물 절리 시 근로자 맞음 방지',
    개선대책: '1. 근로자와 충분한 작업거리 확보\n' +
      '2. 출입금지 구역 설정',
  },
  { id: 7, 작업내용: '철거공사',
    유해위험요인: '재활용 처리 크레인 운용 시 안전사항',
    개선대책: '1. 정격하중 준수 및 넘어짐 방지 조치 실시',
  },
]
